module.exports = __webpack_public_path__ + "static/media/cancel-icon.1dab083a.svg";